// Objective: Define the service to get the loan leads
import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';


export async function getInsights(filterObj: Object = {}) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/all/dashboard`,
  }); 
  return response;
}

export async function getMonthlyOutstandingReport() {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/reports/monthly-outstanding`,
  }); 
  return response;
}

export async function sendMonthlyOutstandingReportEmail() {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/reports/monthly-outstanding/send-email`,
    data: {},
  }); 
  return response;
}

export async function getLendingClassification() {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/lending-classification`,
  }); 
  return response;
}

export async function getCurrentYearCashflow() {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/current-year-cashflow`,
  }); 
  return response;
}

export async function sendAccountStatementEmail() {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/reports/account-statement/send-email`,
    data: {},
  }); 
  return response;
}

/**
 * Get all short-term debits that are due in the current month.
 * Used on the admin lending dashboard to highlight upcoming short-term debit maturities.
 */
export async function getShortTermDebitsDueThisMonth() {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/short-term-debits/due-this-month`,
  }); 
  return response.data || response;
}

/**
 * Generate monthly report for current month
 */
export async function generateMonthlyReport() {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/monthly-report`,
  }); 
  return response.data || response;
}

/**
 * Generate and send monthly report via email
 * @param email Optional email address (defaults to configured report email)
 */
export async function sendMonthlyReportEmail(email?: string) {
  const params = email ? { email } : {};
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/monthly-report/send-email`,
    params: params,
  }); 
  return response.data || response;
}